"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Icons = require("../Icons");

var _Icon = require("../Icon");

var animationLoader = (0, _styledComponents.keyframes)(["0%{transform:rotate(0);}100%{transform:rotate(360deg);}"]);
var StyleLoaderOne = (0, _styledComponents.default)(_Icons.Spinner).withConfig({
  displayName: "Loader__StyleLoaderOne",
  componentId: "sc-1u5aque-0"
})(["", ";animation:", " 2s infinite linear;"], _styledSystem.color, animationLoader);

var Loader = function Loader(props) {
  return _react.default.createElement(_Icon.Icon, props, _react.default.createElement(StyleLoaderOne, null));
};

exports.Loader = Loader;